var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayout11(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 90,
    viewBox: "0 0 160 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 90,
    fill: "#666666"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 6,
    width: 42,
    height: 6,
    rx: 3,
    fill: "#CCCCCC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 79.5,
    y: 3,
    width: 1,
    height: 84,
    rx: 0.5,
    fill: "#CCCCCC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 6,
    width: 42,
    height: 6,
    rx: 3,
    fill: "#CCCCCC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 6,
    width: 16,
    height: 6,
    rx: 3,
    fill: "#CCCCCC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 16,
    height: 6,
    rx: 3,
    fill: "#CCCCCC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 18,
    width: 72,
    height: 3.65,
    fill: "#CCCCCC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 23.65,
    width: 72,
    height: 3.65,
    fill: "#CCCCCC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 29.3,
    width: 72,
    height: 3.65,
    fill: "#CCCCCC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 34.95,
    width: 72,
    height: 3.65,
    fill: "#CCCCCC"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 40.6,
    width: 72,
    height: 3.65,
    fill: "#CCCCCC"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 46.25,
    width: 72,
    height: 3.65,
    fill: "#CCCCCC"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 51.9,
    width: 72,
    height: 3.65,
    fill: "#CCCCCC"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 57.55,
    width: 72,
    height: 3.65,
    fill: "#CCCCCC"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 63.2,
    width: 72,
    height: 3.65,
    fill: "#CCCCCC"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 68.85,
    width: 72,
    height: 3.65,
    fill: "#CCCCCC"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 74.5,
    width: 72,
    height: 3.65,
    fill: "#CCCCCC"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 80.15,
    width: 72,
    height: 3.65,
    fill: "#CCCCCC"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 18,
    width: 72,
    height: 3.65,
    fill: "#CCCCCC"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 23.65,
    width: 72,
    height: 3.65,
    fill: "#CCCCCC"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 29.3,
    width: 72,
    height: 3.65,
    fill: "#CCCCCC"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 34.95,
    width: 72,
    height: 3.65,
    fill: "#CCCCCC"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 40.6,
    width: 72,
    height: 3.65,
    fill: "#CCCCCC"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 46.25,
    width: 72,
    height: 3.65,
    fill: "#CCCCCC"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 51.9,
    width: 72,
    height: 3.65,
    fill: "#CCCCCC"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 57.55,
    width: 72,
    height: 3.65,
    fill: "#CCCCCC"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 63.2,
    width: 72,
    height: 3.65,
    fill: "#CCCCCC"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 68.85,
    width: 72,
    height: 3.65,
    fill: "#CCCCCC"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 74.5,
    width: 72,
    height: 3.65,
    fill: "#CCCCCC"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 80.15,
    width: 72,
    height: 3.65,
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayout11);
export default __webpack_public_path__ + "static/media/layout11.92ea3106ed90454cb9dfdca23e3144bc.svg";
export { ForwardRef as ReactComponent };